import * as Api from "api";
import { CREATE_UPLOAD } from "constants/uploads";
import { networkAction } from "helpers/network/networkAction";

export const upload = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_UPLOAD, Api.upload, [body]);
